import { Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';
import { DeleteFormStrategy } from './delete-form.interface';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';

@Component({
  selector: 'ocp-delete-form',
  templateUrl: './delete-form.component.html',
  styleUrls: ['./delete-form.component.scss'],
  imports: [HlmButtonImports, TranslatePipe, ThemedIconComponent],
})
export class DeleteFormComponent {
  protected readonly dynamicDialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef, {
    optional: true,
  });
  private readonly data = injectBrnDialogContext<{ strategy?: DeleteFormStrategy }>({
    optional: true,
  });
  protected readonly strategy: DeleteFormStrategy =
    this.data?.strategy ?? inject(DeleteFormStrategy, { optional: true })!;
  readonly isDeleting = signal(false);

  protected onDelete(): void {
    this.isDeleting.set(true);
    this.dynamicDialogRef?.close(true);
  }

  protected onCancel(): void {
    this.dynamicDialogRef?.close(false);
  }
}
